import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { Button, CssBaseline, Fab, Grid, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import SearchIcon from '@material-ui/icons/Search';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Topbar from '../components/Topbar';
import Paging from './Paging';
import PosterItems from './PosterItems';

import AppBar from '@material-ui/core/AppBar';
import { EVENT_ID, POSTER_API_URL } from '../constants';
import axios from 'axios';
import PosterSearch from './PosterSearch';
import { ArrowUpward, RotateLeft } from '@material-ui/icons';

const PosterTabs = withStyles((theme) => ({
  root: {
    backgroundColor: '#ffffff',
    borderBottom: '4px solid ',
    borderBottomColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& .MuiTabs-scrollButtons': {
      '&:not(.Mui-disabled)': {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        opacity: 1,
      },
    },
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: '2.4em',
    },
  },
  indicator: {
    background: 'none',
    color: '#ffffff',
  },
  scrollButtons: {
    color: theme.palette.primary.main,
    '&:active': {
      backgroundColor: theme.palette.primary.main,
      color: '#ffffff',
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: '#ffffff',
    },
  },
}))((props) => <Tabs {...props} />);

const PosterTab = withStyles((theme) => ({
  root: {
    minWidth: '190px',
    maxWidth: '190px',
    color: 'rgba(1,1,1,0.8)',
    minHeight: '80px',
    textTransform: 'none',
    fontSize: 'large',

    '&:hover': {
      opacity: 1,
    },
    '&$selected': {
      color: '#ffffff',
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
    '&:focus': {
      // color: '#40a9ff',
    },
  },
  selected: {},
  wrapper: {
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      display: 'block',
      whiteSpace: 'normal',
      msWordWrap: 'break-word',
    },
  },
}))((props) => <Tab {...props} />);

const PosterSelect = withStyles((theme) => ({
  selectMenu: {
    height: '3em',
    whiteSpace: 'normal',
  },
  select: {
    color: '#ffffff',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: '#ffffff',
  },
}))((props) => <Select {...props} />);

const styles = (theme) => ({
  posterDiv: {
    padding: '20px 50px',
    backgroundColor: '#f4f4f4',
    height: 'calc(100% - 85px)',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: '15px 35px 150px',
      height: 'calc(100% - 94.67px)',
      overflowY: 'auto',
    },
  },
  searchBar: {
    backgroundColor: '#fff',
    border: 'solid 1px #c9c9c9',
    borderRadius: '5px',
    '&:focus': {
      border: 'solid 1px #377ac6',
    },
    // width: '300px',
    width: '600px',

    '& input': {
      height: '50px',
      padding: '0 1vw',
      [theme.breakpoints.down('sm')]: {
        height: '55px',
        fontSize: '19px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
    },
  },
  pageDiv: {
    paddingBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  loadMoreDiv: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      borderTop: '1px solid #e0e0e0',
      margin: '0 25px',
      padding: '10px 0',
    },
  },
  mobileTab: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
  },
  tabBox: {
    height: '650px',
    overflowY: 'auto',
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    left: '48%',
  },
});

class Poster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.match.params.id || 0,
      searchkeyword: '',
      tabMenu: JSON.parse(sessionStorage.getItem('Item')).poster,
      postItem: [],
      pageSize: null,
      isMobile: window.matchMedia('(max-width:960px)').matches,
      loadMore: true,
      nowPage: 1,
      postCnt: null,
      delay: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.getPosterData = this.getPosterData.bind(this);
    this.paging = this.paging.bind(this);

    this.searchRef = React.createRef();
  }

  componentDidMount() {
    let tabNo = this.props.match.params.id;
    this.setState({ value: Number(tabNo) });
    this.getPosterData(Number(tabNo), 1);
  }

  getPosterData(_cate, _page) {
    let limit = this.state.isMobile === true ? 3 : 10;
    limit = -1;

    const category = this.state.tabMenu[_cate];

    console.log('키워드 : ' + this.state.searchkeyword);
    const search = this.state.searchkeyword.length > 0 ? '&name=' + this.state.searchkeyword : '';
    axios
      .get(
        `${POSTER_API_URL}/poster/list?tts=${new Date().getTime()}&eventId=${EVENT_ID}&categoryTitle=${category}&limit=${limit}&page=${_page}${search}`,
      )

      .then((res) => {
        let data = res.data.Items;
        data.sort(function (a, b) {
          return a.userNo > b.userNo ? 1 : -1;
        });
        if (data.length) {
          this.setState({ postCnt: res.data.Count });
        }
        if (res.data.pageSize) {
          this.setState({ pageSize: res.data.pageSize });
        }
        this.setState({ postItem: data });

        // if (this.state.isMobile === false) {
        //   this.setState({ postItem: data });
        // } else {
        //   //모바일에서
        //   this.setState({ postItem: this.state.postItem.concat(res.data.Items) });
        //   if (this.state.nowPage < res.data.pageSize) {
        //     this.setState({ loadMore: true });
        //     this.setState({ nowPage: this.state.nowPage + 1 });
        //   } else {
        //     this.setState({ loadMore: false });
        //   }
        // }
        // console.log(this.state.postItem);
      });
  }

  paging(_val) {
    this.getPosterData(this.state.value, _val);
    this.setState({ nowPage: _val });
    // this.setState({ nowPage: _val + 1 });
    // console.log('paging 현재페이지 추가: ' + this.state.nowPage);
  }

  a11yProps = (index) => {
    return {
      // id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  handleChange = (event, newValue) => {
    this.setState({ searchkeyword: '' });
    this.setState({ value: newValue });
    this.getPosterData(newValue, 1);
  };

  // for MOBILE
  handleChange2 = (event) => {
    this.setState({ searchkeyword: '' });
    this.setState({ value: event.target.value });
    this.getPosterData(event.target.value, 1);
  };

  handleSubmit = (event) => {
    event.preventDefault();
  };

  inputChange = (event) => {
    this.setState({ searchkeyword: event.target.value });
    // if (this.state.delay) {
    //   clearTimeout(this.state.delay);
    // }
    // let delay = setTimeout(() => {
    //   if (this.state.isMobile === true) {
    //     this.setState({ nowPage: 1 });
    //     this.setState({ postItem: [] });
    //   }
    //   this.getPosterData(this.state.value, 1);
    // }, 200);
    // this.setState({ delay: delay });
  };

  addList = () => {
    if (this.state.loadMore === true) {
      this.paging(this.state.nowPage);
    }
  };

  scrollTop = () => {
    if (this.state.openSearch) {
      this.searchRef.current.scrollTop();
    } else {
      // eslint-disable-next-line
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const el = document.getElementById('posterBox-' + this.state.value);
      el.scrollTop = scrollTop;
    }
  };

  render() {
    const { classes } = this.props;

    const filteredList = (datas) => {
      if (datas.length > 0) {
        return datas.map((item, idx) => {
          return (
            <PosterItems
              key={idx}
              data={item}
              order={item.order}
              country={item.country}
              regNo={item.regNo}
              email={item.email}
              dept={item.dept}
              presenter={item.presenter}
              position={item.position}
              profession={item.profession}
              ptTitle={item.ptTitle}
              firstName={item.firstName}
              lastName={item.lastName}
              keyword1={item.keyword1}
              keyword2={item.keyword2}
              keyword3={item.keyword3}
            />
          );
        });
      }
    };

    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar currentPath={2} />
        <div className={classes.posterDiv}>
          <Grid container justifyContent={'flex-start'} alignItems={'center'}>
            <form onSubmit={this.handleSubmit} style={{ marginBottom: 10 }}>
              <OutlinedInput
                // startAdornment={
                //   <InputAdornment position="start">
                //     <IconButton disabled>
                //       <SearchIcon />
                //     </IconButton>
                //   </InputAdornment>
                // }

                placeholder="Text search: Presenter, Title, Position "
                value={this.state.searchkeyword}
                onChange={this.inputChange}
                className={classes.searchBar}
                // style={{ width: window.matchMedia('(max-width:992px)').matches ? '80vw' : '30vw' }}
              />
            </form>
            <Button
              color={'primary'}
              variant={'contained'}
              style={{ marginLeft: 10, marginBottom: 10, height: '50px', backgroundColor: '#47ac89' }}
              disableElevation
              startIcon={<SearchIcon />}
              onClick={() => {
                this.setState({ openSearch: true });
                if (this.searchRef && this.searchRef.current) this.searchRef.current.getPosterData(this.state.searchkeyword);
              }}
            >
              Search
            </Button>
            <Button
              variant={'outlined'}
              style={{ marginLeft: 10, marginBottom: 10, height: '50px' }}
              disableElevation
              startIcon={<RotateLeft />}
              onClick={() => {
                this.setState({ openSearch: false, searchkeyword: '' });
              }}
            >
              Reset
            </Button>
            {/* <Grid item style={{ marginLeft: 20, marginBottom: 10 }}>
              <Chip label="Best" style={{ marginRight: 5, backgroundColor: 'gold' }} /> 는 우수초록으로 선정된 초록입니다.
            </Grid> */}
          </Grid>
          {this.state.openSearch ? (
            <div>
              <PosterSearch id={'posterSearchBox'} keyword={this.state.searchkeyword} ref={this.searchRef} />
            </div>
          ) : (
            <div style={{ backgroundColor: '#fff', marginBottom: '20px' }}>
              <AppBar position="static" color="default">
                <PosterTabs value={this.state.value} variant="scrollable" scrollButtons="on" onChange={this.handleChange}>
                  {this.state.tabMenu.map((menu, idx) => {
                    return <PosterTab label={menu} key={idx} {...this.a11yProps({ idx })} />;
                  })}
                </PosterTabs>
              </AppBar>

              <div className={classes.mobileTab}>
                <PosterSelect defaultValue={this.state.value} value={this.state.value} onChange={this.handleChange2}>
                  {this.state.tabMenu.map((menu, idx) => {
                    return (
                      <MenuItem value={idx} key={idx}>
                        {menu}
                      </MenuItem>
                    );
                  })}
                </PosterSelect>
              </div>

              {this.state.tabMenu.map((menu, i) => {
                return (
                  <Typography component="div" hidden={this.state.value !== i} index={i} key={i}>
                    {this.state.isMobile ? (
                      <Box p={3} style={{ minHeight: '350px' }}>
                        {filteredList(this.state.postItem)}
                      </Box>
                    ) : (
                      <Box p={3} className={classes.tabBox} id={'posterBox-' + i}>
                        {filteredList(this.state.postItem)}
                      </Box>
                    )}
                  </Typography>
                );
              })}

              {/* <div className={classes.loadMoreDiv}>
                {this.state.loadMore ? (
                  <Button className={classes.loadMoreBtn} onClick={this.addList}>
                    더보기&nbsp;
                    <ExpandMoreIcon />
                  </Button>
                ) : (
                  ''
                )}
              </div> */}
            </div>
          )}
          {!this.state.isMobile && (
            <Fab size="small" color="primary" aria-label="top" onClick={this.scrollTop} className={classes.fab}>
              <ArrowUpward />
            </Fab>
          )}
          <div className={classes.pageDiv}>
            {this.state.pageSize ? <Paging change={this.paging} data={this.state.pageSize} defaultPage={this.state.nowPage} /> : ''}
          </div>
        </div>
        {/*<Footer style={{ bottom: '10px !important' }} />*/}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Poster);
